import { render } from "./features-showcase.vue?vue&type=template&id=2b4b1a5a&scoped=true&ts=true"
import script from "./features-showcase.vue?vue&type=script&lang=ts"
export * from "./features-showcase.vue?vue&type=script&lang=ts"

import "./features-showcase.vue?vue&type=style&index=0&id=2b4b1a5a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4b1a5a"]])

export default __exports__